import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SharedLogService {
  constructor() {
    //
  }

  public log(message: string) {
    // No-op in production builds. Diagnostic logging was removed to keep
    // internal routing paths, booking IDs, and data-flow details out of the
    // deployed browser console (#672). Signature retained for existing callers.
    void message;
  }
}
